import React from 'react';
import { ShoppingBag, ArrowBigUpDash, MessageSquare, Zap } from 'lucide-react';
import styles from './Dashboard.module.css';

export default function Overview() {
  const metrics = [
    { label: 'Active Orders', value: '2', icon: ShoppingBag },
    { label: 'Upvotes Delivered', value: '3,450', icon: ArrowBigUpDash },
    { label: 'Comments Placed', value: '42', icon: MessageSquare },
    { label: 'Karma Built', value: '1,200', icon: Zap },
  ];

  const activityFeed = [
    { id: 1, text: '50 upvotes delivered to r/startups post', time: '2 hours ago' },
    { id: 2, text: '3 comments placed in r/SaaS', time: '5 hours ago' },
    { id: 3, text: 'Karma build in progress — 340/1000', time: '1 day ago' },
    { id: 4, text: 'Order #1042 completed', time: '2 days ago' },
    { id: 5, text: 'Plan upgraded to Standard', time: '1 week ago' },
  ];

  return (
    <div className={styles.page}>
      <div className={styles.pageHeader}>
        <h1 className={styles.pageTitle}>Overview</h1>
        <p className={styles.pageSubtitle}>Welcome back! Here's what's happening with your accounts.</p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '24px', marginBottom: '32px' }}>
        {metrics.map(m => (
          <div key={m.label} className={styles.card}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
              <div style={{ color: 'var(--text2)', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>{m.label}</div>
              <m.icon size={20} className="text-accent" strokeWidth={1.5} />
            </div>
            <div style={{ fontSize: '32px', fontFamily: 'var(--font-head)', fontWeight: '700', color: 'var(--text)' }}>{m.value}</div>
          </div>
        ))}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '24px' }}>
        
        {/* Activity Feed */}
        <div className={styles.card}>
          <h2 className={styles.cardTitle}>Recent Activity</h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {activityFeed.map(feed => (
              <div key={feed.id} style={{ display: 'flex', flexDirection: 'column', paddingBottom: '16px', borderBottom: '1px solid var(--border)' }}>
                <div style={{ color: 'var(--text)', fontSize: '14px', fontWeight: '500' }}>{feed.text}</div>
                <div style={{ color: 'var(--text2)', fontSize: '12px', marginTop: '4px' }}>{feed.time}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Plan Info */}
        <div className={styles.card} style={{ height: 'fit-content' }}>
          <h2 className={styles.cardTitle}>Current Plan</h2>
          <div style={{ padding: '16px', background: 'var(--bg3)', borderRadius: 'var(--radius-sm)', border: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div>
              <div style={{ fontWeight: '600', color: 'var(--text)' }}>Standard Plan</div>
              <div style={{ fontSize: '13px', color: 'var(--text2)', marginTop: '4px' }}>Renews on Nov 15, 2026</div>
            </div>
            <span className={`${styles.badge} ${styles.badgeGreen}`}>Active</span>
          </div>
        </div>

      </div>
    </div>
  );
}
